import React from 'react';
import { Link } from 'react-router-dom';
import { DashboardLayout } from '../../components/layouts';
import styles from './style.module.css';

export default function Dashboard() {
  return (
    <DashboardLayout>
      <div className={styles.root}>
        <h1 className={styles.pageTitle}>Dashboard</h1>
        <br />
        <br />
        <p className={styles.pageContent}>
          <b>Step 1 : Identifikasi |</b> Nilai risiko terkait air dengan
          menganalisis detail tingkat fasilitas di Dasbor Fasilitas ini dan
          menjelajahi Dasbor Perusahaan dari navigasi sebelah kiri. Dalam Dasbor
          Perusahaan, pahami profil risiko organisasi Anda di tab Analisis
          Risiko dan bandingkan kinerja berbagai situs dalam portofolio di tab
          Pembandingan.
        </p>
        <br />
        <p className={styles.pageContent}>
          <b>Step 2 : Target |</b> Di Dasbor Fasilitas ini, klik tombol Tetapkan
          Target untuk setiap fasilitas yang diberikan untuk mengetahui target
          penarikan air tahunan yang berkelanjutan yang akan diberikan pada
          penarikan air saat ini dan tekanan air dasar.
        </p>
        <br />
        <p className={styles.pageContent}>
          <b>Step 3 : Pemantauan |</b> Untuk setiap fasilitas yang diberikan
          pada Dasbor Fasilitas ini, pantau penggunaan air dari waktu ke waktu
          dengan memasukkan data beberapa tahun dan mengklik Kinerja fasilitas.
        </p>
      </div>
      <br />
      <br />
      <br />
      <p className={styles.pageContent}>Menu Utama :</p>
      <br />
      <p className={`${styles.pageContent} ${styles.pageContentLink}`}>
        <Link to="/facility">Fasilitas</Link>
        <span className={styles.divider}>|</span>
        <Link to="/questionnaire">Kuesioner</Link>
      </p>
      <div className={styles.endContent}></div>
    </DashboardLayout>
  );
}
